import {nQuery} from "../main.js";

export default objects => nQuery([objects[0]])
